export default function Logo({ dark = false, size = 48 }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none" data-testid="header-logo">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Settalkar logo — traffic challan legal settlement"
        width={size}
        height={size}
        className="rounded-full shadow-md shadow-brand-blue/25 shrink-0"
        style={{ width: size, height: size }}
      />
      <span className="font-display text-2xl font-bold tracking-tight leading-none whitespace-nowrap">
        <span className={dark ? 'text-white' : 'text-[#1042B0]'}>Settal</span>
        <span className="text-[#FF7700]">kar</span>
        <span className={dark ? 'text-white/40' : 'text-[#94A3B8]'}>.com</span>
      </span>
    </span>
  );
}
